/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { vappContainer } from '@/application';
import { ActualDetailPageService } from '@pages/ActualDetailPage/services';

const MODULE_NAME = 'ActualDetailPage.machines.states.TransactionList';

const getSrv = () => {
  return vappContainer.get<ActualDetailPageService>(
    ActualDetailPageService.displayName
  );
};

export const getTransactionList = async (context: any, event: any) => {
  const currentState = 'GET_PAGE_CONTENT';
  const method = 'getTransactionList';

  return new Promise(async (resolve, reject) => {
    try {
      const srv = getSrv();
      const content = await srv.agent?.getTransactionList();

      if (content) {
        return resolve({
          key: 'GET_TRANSACTION_LIST',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        return reject({
          key: 'GET_TRANSACTION_LIST_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'GET_TRANSACTION_LIST_ERROR',
        value: _msg,
      });
    }
  });
};
